/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Dokumentenverweis } from '../models';
// @ts-ignore
import { FileDto } from '../models';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { MetadataRequest } from '../models';
/**
 * DokumentenverweisService - axios parameter creator
 * @export
 */
export const DokumentenverweisServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Löscht ein Dokumentenverweis
         * @summary Dokumentenverweis löschen
         * @param {number} dokumentverweisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBydokumentenverweisId: async (dokumentverweisId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dokumentverweisId' is not null or undefined
            assertParamExists('deleteBydokumentenverweisId', 'dokumentverweisId', dokumentverweisId)
            const localVarPath = `/api/dokumentenverweise/{dokumentverweisId}`
                .replace(`{${"dokumentverweisId"}}`, encodeURIComponent(String(dokumentverweisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Dokumentenverweise
         * @summary Dokumentenverweise
         * @param {number} auftragId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByAuftragId: async (auftragId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'auftragId' is not null or undefined
            assertParamExists('getByAuftragId', 'auftragId', auftragId)
            const localVarPath = `/api/dokumentenverweise/auftrag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (auftragId !== undefined) {
                localVarQueryParameter['auftrag.id'] = auftragId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert ein Binary File oder (Image holen als Base64 String)
         * @summary das FileDto anhand der dokumentenverweis id
         * @param {number} dokumentverweisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDtoBydokumentenverweisId: async (dokumentverweisId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dokumentverweisId' is not null or undefined
            assertParamExists('getFileDtoBydokumentenverweisId', 'dokumentverweisId', dokumentverweisId)
            const localVarPath = `/api/dokumentenverweise/file/{dokumentverweisId}`
                .replace(`{${"dokumentverweisId"}}`, encodeURIComponent(String(dokumentverweisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a File
         * @summary Upload a File
         * @param {string} filename File Name
         * @param {number} [objectId] Referenz ID des auftrags
         * @param {any} [file] image file
         * @param {MetadataRequest} [metadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (filename: string, objectId?: number, file?: any, metadata?: MetadataRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('uploadFile', 'filename', filename)
            const localVarPath = `/api/dokumentenverweise/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['objectId'] = objectId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (metadata !== undefined) { 
                localVarFormParams.append('metadata', new Blob([JSON.stringify(metadata)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DokumentenverweisService - functional programming interface
 * @export
 */
export const DokumentenverweisServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DokumentenverweisServiceAxiosParamCreator(configuration)
    return {
        /**
         * Löscht ein Dokumentenverweis
         * @summary Dokumentenverweis löschen
         * @param {number} dokumentverweisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBydokumentenverweisId(dokumentverweisId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBydokumentenverweisId(dokumentverweisId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Dokumentenverweise
         * @summary Dokumentenverweise
         * @param {number} auftragId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByAuftragId(auftragId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dokumentenverweis>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByAuftragId(auftragId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert ein Binary File oder (Image holen als Base64 String)
         * @summary das FileDto anhand der dokumentenverweis id
         * @param {number} dokumentverweisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileDtoBydokumentenverweisId(dokumentverweisId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileDtoBydokumentenverweisId(dokumentverweisId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload a File
         * @summary Upload a File
         * @param {string} filename File Name
         * @param {number} [objectId] Referenz ID des auftrags
         * @param {any} [file] image file
         * @param {MetadataRequest} [metadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(filename: string, objectId?: number, file?: any, metadata?: MetadataRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(filename, objectId, file, metadata, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DokumentenverweisService - factory interface
 * @export
 */
export const DokumentenverweisServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DokumentenverweisServiceFp(configuration)
    return {
        /**
         * Löscht ein Dokumentenverweis
         * @summary Dokumentenverweis löschen
         * @param {number} dokumentverweisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBydokumentenverweisId(dokumentverweisId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBydokumentenverweisId(dokumentverweisId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Dokumentenverweise
         * @summary Dokumentenverweise
         * @param {number} auftragId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByAuftragId(auftragId: number, options?: any): AxiosPromise<Array<Dokumentenverweis>> {
            return localVarFp.getByAuftragId(auftragId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert ein Binary File oder (Image holen als Base64 String)
         * @summary das FileDto anhand der dokumentenverweis id
         * @param {number} dokumentverweisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDtoBydokumentenverweisId(dokumentverweisId: number, options?: any): AxiosPromise<FileDto> {
            return localVarFp.getFileDtoBydokumentenverweisId(dokumentverweisId, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a File
         * @summary Upload a File
         * @param {string} filename File Name
         * @param {number} [objectId] Referenz ID des auftrags
         * @param {any} [file] image file
         * @param {MetadataRequest} [metadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(filename: string, objectId?: number, file?: any, metadata?: MetadataRequest, options?: any): AxiosPromise<void> {
            return localVarFp.uploadFile(filename, objectId, file, metadata, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DokumentenverweisService - interface
 * @export
 * @interface DokumentenverweisService
 */
export interface DokumentenverweisServiceInterface {
    /**
     * Löscht ein Dokumentenverweis
     * @summary Dokumentenverweis löschen
     * @param {number} dokumentverweisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisServiceInterface
     */
    deleteBydokumentenverweisId(dokumentverweisId: number, options?: any): AxiosPromise<void>;

    /**
     * Liefert Dokumentenverweise
     * @summary Dokumentenverweise
     * @param {number} auftragId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisServiceInterface
     */
    getByAuftragId(auftragId: number, options?: any): AxiosPromise<Array<Dokumentenverweis>>;

    /**
     * Liefert ein Binary File oder (Image holen als Base64 String)
     * @summary das FileDto anhand der dokumentenverweis id
     * @param {number} dokumentverweisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisServiceInterface
     */
    getFileDtoBydokumentenverweisId(dokumentverweisId: number, options?: any): AxiosPromise<FileDto>;

    /**
     * Upload a File
     * @summary Upload a File
     * @param {string} filename File Name
     * @param {number} [objectId] Referenz ID des auftrags
     * @param {any} [file] image file
     * @param {MetadataRequest} [metadata] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisServiceInterface
     */
    uploadFile(filename: string, objectId?: number, file?: any, metadata?: MetadataRequest, options?: any): AxiosPromise<void>;

}

/**
 * DokumentenverweisService - object-oriented interface
 * @export
 * @class DokumentenverweisService
 * @extends {BaseAPI}
 */
export class DokumentenverweisService extends BaseAPI implements DokumentenverweisServiceInterface {
    /**
     * Löscht ein Dokumentenverweis
     * @summary Dokumentenverweis löschen
     * @param {number} dokumentverweisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisService
     */
    public deleteBydokumentenverweisId(dokumentverweisId: number, options?: any) {
        return DokumentenverweisServiceFp(this.configuration).deleteBydokumentenverweisId(dokumentverweisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Dokumentenverweise
     * @summary Dokumentenverweise
     * @param {number} auftragId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisService
     */
    public getByAuftragId(auftragId: number, options?: any) {
        return DokumentenverweisServiceFp(this.configuration).getByAuftragId(auftragId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert ein Binary File oder (Image holen als Base64 String)
     * @summary das FileDto anhand der dokumentenverweis id
     * @param {number} dokumentverweisId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisService
     */
    public getFileDtoBydokumentenverweisId(dokumentverweisId: number, options?: any) {
        return DokumentenverweisServiceFp(this.configuration).getFileDtoBydokumentenverweisId(dokumentverweisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a File
     * @summary Upload a File
     * @param {string} filename File Name
     * @param {number} [objectId] Referenz ID des auftrags
     * @param {any} [file] image file
     * @param {MetadataRequest} [metadata] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumentenverweisService
     */
    public uploadFile(filename: string, objectId?: number, file?: any, metadata?: MetadataRequest, options?: any) {
        return DokumentenverweisServiceFp(this.configuration).uploadFile(filename, objectId, file, metadata, options).then((request) => request(this.axios, this.basePath));
    }
}
